import { flightService } from "@/service/index.js";
export default {
   data() {
      return {
         selection: {},
         hoverRemove: {},
         hoverColumn: {},
      };
   },

   methods: {
      handlerUpdateBasket() {
         this.$store.commit("app/setIsProgressGifActive", true);
         let query = this.$store.state.flight.checkout.request;

         flightService.checkout(query).then((response) => {
            this.$store.commit("flight/updateCheckoutResponse", response.checkoutResponse);
            this.$store.commit("flight/updateCheckoutRequest", response.checkoutRequest);
            this.$store.commit("flight/updateCheckoutUuid", response.checkoutUuid);
            this.$store.commit("app/setIsProgressGifActive", false);
            this.$store.state.app.progress.message = "";
         });
      },
      getSelectedSSRsForPax(pax) {
         const selectedSSRs = new Set();

         pax.segments.forEach((segment) => {
            Object.entries(segment.ssrs).forEach(([ssrType, ssr]) => {
               if (ssr.selected && !ssr.isFreeConjuncted) {
                  selectedSSRs.add(ssrType);
               }
            });
         });

         return Array.from(selectedSSRs);
      },

      clearSSR(ssr, ssrType, paxId, segmentIndex, flightIdentifier) {
         const wasInBasket = ssr.inBasket;

         this.$store.commit("flight/updateCheckoutSsr", {
            flightIdentifier: flightIdentifier,
            identifier: ssr.eligibleKey,
            status: true,
         });

         this.$store.commit("flight/updatePaxCheckoutSSR", {
            paxId,
            ssrType,
            route: this.getSegmentRoute(paxId, segmentIndex),
            flightIdentifier,
            status: false,
         });

         if (!this.selection[paxId]) {
            this.$set(this.selection, paxId, {});
         }
         this.$set(this.selection[paxId], segmentIndex, {
            ...this.selection[paxId][segmentIndex],
            [ssrType]: null,
         });
         flightIdentifier;

         ssr.selected = false;
         ssr.label = null;
         ssr.name = null;
         ssr.description = null;
         ssr.price = null;
         ssr.eligibleKey = null;
         ssr.inBasket = false;

         this.clearConjunctedSegments(ssrType, paxId, segmentIndex);
         this.clearHoverRemove(paxId, ssrType);

         if (wasInBasket) {
            this.handlerUpdateBasket();
         }
      },

      getSegmentRoute(paxId, segmentIndex) {
         const pax = this.SSRs.paxes.find((p) => p.id === paxId);
         const segment = pax?.segments[segmentIndex - 1];
         if (!segment) return null;
         return `${segment.departureAirportCode}-${segment.arrivalAirportCode}`;
      },

      selectSSR(ssr, option, ssrType, paxId, segmentIndex, flightIdentifier) {
         if (!this.selection[paxId]) {
            this.$set(this.selection, paxId, {});
         }
         this.$set(this.selection[paxId], segmentIndex, {
            ...this.selection[paxId][segmentIndex],
            [ssrType]: option.eligibleKey,
         });
         ssr.label = option.label;
         ssr.name = option.ssrSubType;
         ssr.description = option.description;
         ssr.price = option.price?.parsedValue ?? option.price;
         ssr.eligibleKey = option.eligibleKey;
         ssr.selected = true;
         ssr.makingSelection = false;

         this.$store.commit("flight/updateCheckoutSsr", {
            flightIdentifier: flightIdentifier,
            identifier: option.eligibleKey,
            status: false,
         });

         this.$store.commit("flight/updatePaxCheckoutSSR", {
            paxId,
            ssrType,
            route: this.getSegmentRoute(paxId, segmentIndex),
            flightIdentifier,
            status: true,
         });

         this.selectConjunctedSegments(ssrType, paxId, segmentIndex, option, flightIdentifier);
         this.clearHoverRemove(paxId, ssrType);
      },

      selectConjunctedSegments(ssrType, paxId, selectedSegmentIndex, option, flightIdentifier) {
         const pax = this.SSRs.paxes.find((p) => p.id === paxId);
         if (!pax) return;

         pax.segments.forEach((segment, index) => {
            const segmentIndex = index + 1;
            const ssrItem = segment.ssrs[ssrType];

            if (segmentIndex !== selectedSegmentIndex && ssrItem?.isConjuncted) {
               // FREE conjuncted segment'in key'ini option'dan al
               const keyFromOption = option.eligiblePaxSegmentKeys?.[paxId]?.[segmentIndex];
               const conjunctedEligibleKey = keyFromOption?.key || null;

               this.updateConjunctedSegment(ssrType, paxId, segmentIndex, {
                  selected: true,
                  name: option.ssrSubType,
                  label: option.label,
                  description: option.description,
                  price: 0,
                  isFreeConjuncted: true,
                  eligibleKey: conjunctedEligibleKey,
               });

               if (conjunctedEligibleKey) {
                  this.$store.commit("flight/updateCheckoutSsr", {
                     flightIdentifier,
                     identifier: conjunctedEligibleKey,
                     status: false,
                  });
               }
            }
         });
      },

      clearConjunctedSegments(ssrType, paxId, clearedSegmentIndex) {
         const pax = this.SSRs.paxes.find((p) => p.id === paxId);
         if (!pax) return;

         pax.segments.forEach((segment, index) => {
            const segmentIndex = index + 1;
            if (segmentIndex !== clearedSegmentIndex && segment.ssrs[ssrType]?.isFreeConjuncted) {
               this.updateConjunctedSegment(ssrType, paxId, segmentIndex, {
                  selected: false,
                  name: null,
                  description: null,
                  price: null,
                  isFreeConjuncted: false,
               });
            }
         });
      },

      updateConjunctedSegment(ssrType, paxId, segmentIndex, values) {
         const pax = this.SSRs.paxes.find((p) => p.id === paxId);
         if (!pax?.segments[segmentIndex - 1]) return;

         const ssrItem = pax.segments[segmentIndex - 1].ssrs[ssrType];
         if (!ssrItem) return;

         if (!this.selection[paxId]) {
            this.$set(this.selection, paxId, {});
         }
         this.$set(this.selection[paxId], segmentIndex, {
            ...this.selection[paxId][segmentIndex],
            [ssrType]: values.isFreeConjuncted ? null : values.eligibleKey,
         });

         Object.assign(ssrItem, values);
      },

      closeAllDropdowns() {
         this.SSRs.paxes.forEach((pax) => pax.segments.forEach((segment) => Object.values(segment.ssrs).forEach((ssr) => (ssr.makingSelection = false))));
      },

      setHoverColumn(identifier) {
         this.$set(this.hoverColumn, identifier, true);
      },

      clearHoverColumn(identifier) {
         this.$set(this.hoverColumn, identifier, false);
      },

      clearColumn(identifier, flightIdentifier) {
         let hasBasketItem = false;

         this.SSRs.paxes.forEach((pax) => {
            pax.segments.forEach((segment, index) => {
               const ssr = segment.ssrs[identifier];
               if (!ssr?.selected || ssr.isFreeConjuncted) return;

               if (ssr.inBasket) hasBasketItem = true;

               this.$store.commit("flight/updateCheckoutSsr", {
                  flightIdentifier,
                  identifier: ssr.eligibleKey,
                  status: true,
               });

               this.$store.commit("flight/updatePaxCheckoutSSR", {
                  paxId: pax.id,
                  ssrType: identifier,
                  route: this.getSegmentRoute(pax.id, index + 1),
                  flightIdentifier,
                  status: false,
               });

               ssr.selected = false;
               ssr.label = null;
               ssr.name = null;
               ssr.description = null;
               ssr.price = null;
               ssr.eligibleKey = null;
               ssr.inBasket = false;

               this.clearConjunctedSegments(identifier, pax.id, index + 1);
            });
         });

         if (hasBasketItem) {
            this.handlerUpdateBasket();
         }
      },

      setHoverRemove(paxId, ssrType) {
         this.$set(this.hoverRemove, `${paxId}_${ssrType}`, true);
      },

      clearHoverRemove(paxId, ssrType) {
         this.$set(this.hoverRemove, `${paxId}_${ssrType}`, false);
      },

      isConjunctedHovered(paxId, ssrType) {
         return !!this.hoverRemove[`${paxId}_${ssrType}`];
      },
   },

   computed: {
      ssrNotes() {
         const notes = [];

         // Zorunlu SSR kontrolü
         const mandatoryColumns = new Set();
         this.SSRs.paxes?.forEach((pax) => {
            pax.segments.forEach((segment) => {
               Object.entries(segment.ssrs).forEach(([ssrType, ssr]) => {
                  if (ssr.isMandatory) {
                     mandatoryColumns.add(ssrType);
                  }
               });
            });
         });

         // Zorunlu SSR notu ekle
         if (mandatoryColumns.size > 0) {
            const mandatoryLabels = Array.from(mandatoryColumns)
               .map((col) => this.$t(`CheckoutSSRs_lbl${this.SSRs.columns.find((c) => c.identifier === col)?.label}`))
               .join(", ");
            notes.push({
               label: null,
               text: this.$t("CheckoutSSRs_noteMandatorySSR", { ssrTypes: mandatoryLabels }),
               isMandatory: true,
            });
         }

         this.SSRs.columns?.forEach((column) => {
            const label = this.$t(`CheckoutSSRs_lbl${column.label}`);
            notes.push({ label, text: this.$t(`CheckoutSSRs_noteExtraAdded${column.label}`) });
         });

         return notes;
      },

      SSRs() {
         return this.data;
      },

      ssrTotals() {
         const totals = {};

         this.SSRs.paxes.forEach((pax) => {
            pax.segments.forEach((segment, segmentIndex) => {
               Object.entries(segment.ssrs).forEach(([ssrType, ssr]) => {
                  const key = `${ssrType}_${segmentIndex + 1}`;

                  if (!totals[key]) {
                     totals[key] = { count: 0, price: 0 };
                  }

                  if (ssr.selected && !ssr.isFreeConjuncted) {
                     totals[key].count++;
                     totals[key].price += ssr.price || 0;
                  }
               });
            });
         });

         return totals;
      },

      combinedTotals() {
         const totals = {};

         this.SSRs.paxes.forEach((pax) => {
            pax.segments.forEach((segment) => {
               Object.entries(segment.ssrs).forEach(([ssrType, ssr]) => {
                  if (!totals[ssrType]) {
                     totals[ssrType] = { count: 0, price: 0 };
                  }

                  if (ssr.selected && !ssr.isFreeConjuncted) {
                     totals[ssrType].count++;
                     totals[ssrType].price += ssr.price || 0;
                  }
               });
            });
         });

         return totals;
      },

      grandTotal() {
         let total = 0;
         this.SSRs.paxes.forEach((pax) => {
            pax.segments.forEach((segment) => {
               Object.values(segment.ssrs).forEach((ssr) => {
                  if (ssr.selected && !ssr.isFreeConjuncted) {
                     total += ssr.price || 0;
                  }
               });
            });
         });
         return total;
      },

      isMandatoryMissing() {
         let hasMandatoryMissing = false;

         this.SSRs.paxes.forEach((pax) => {
            pax.segments.forEach((segment) => {
               Object.values(segment.ssrs).forEach((ssr) => {
                  if (ssr.isMandatory && !ssr.selected) {
                     hasMandatoryMissing = true;
                  }
               });
            });
         });

         this.$store.commit("flight/setMandatorySSRMissing", hasMandatoryMissing);

         return hasMandatoryMissing;
      },
   },
};
